import { useCallback, useState } from 'react';
import api from '../utils/api.util';
import toast from '../utils/toast.util';
import { ENDPOINT } from '../constants/common-app.const';

const CLIENT_TYPE_MAP: Record<string, string> = {
  legal: 'legal_entity',
  ip: 'sole_proprietor',
  individual: 'individual',
};

export interface CreateContractPayload {
  courseId: string;
  groupId: string | null;
  consentGiven: boolean;
  clientType: string;
  manuallyEntered: boolean;
  vkods?: string | null;
  form: {
    unp: string;
    organization: string;
    legalAddress: string;
    postalAddress: string;
    postalDiffers: boolean;
    phone: string;
    email: string;
    signerName: string;
    signerPosition: string;
    signingBasis: string;
    funding: string;
    passportNumber: string;
    passportIssueDate: string;
    passportIssuer: string;
    individualFullName: string;
  };
}

const useCreateContract = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createContract = useCallback(async (payload: CreateContractPayload): Promise<{ contractId: string; contractUuid: string }> => {
    try {
      setLoading(true);
      const body = {
        courseId: payload.courseId,
        groupId: payload.groupId || null,
        consentGiven: payload.consentGiven,
        client: {
          clientType: CLIENT_TYPE_MAP[payload.clientType] ?? payload.clientType,
          manuallyEntered: payload.manuallyEntered,
          vkods: payload.vkods || null,
          vnaimp: payload.form.organization || null,
          unp: payload.form.unp || null,
          legalAddress: payload.form.legalAddress || null,
          postalAddress: payload.form.postalAddress || null,
          postalDiffers: payload.form.postalDiffers,
          contactPhone: payload.form.phone || null,
          contactEmail: payload.form.email || null,
          signatoryFio: payload.form.signerName || null,
          signatoryPosition: payload.form.signerPosition || null,
          signatoryBasis: payload.form.signingBasis || null,
          fioRu: payload.form.individualFullName || null,
          fioBy: null,
          passportNumber: payload.form.passportNumber || null,
          passportIssueDate: payload.form.passportIssueDate || null,
          passportIssuedBy: payload.form.passportIssuer || null,
          financingSource: payload.form.funding || null,
        },
      };
      const response = await api.postJson(ENDPOINT.CONTRACTS, body);
      setLoading(false);
      return { contractId: response.contract.id, contractUuid: response.contract.uuid };
    } catch (err: any) {
      const status = err?.statusCode ?? err?.status;
      if (status === 422) {
        toast.showOnFailure('Этот тип клиента недоступен для выбранного курса');
      } else {
        toast.showOnFailure('Ошибка создания договора');
      }
      setError('create failed');
      setLoading(false);
      throw err;
    }
  }, []);

  return { createContract, loading, error };
};

export default useCreateContract;
